import React from 'react'
import Navbar from '../components/Navbar'
import Slider from '../components/Slider'
import Footer from '../components/Footer'
import Contact from '../components/Contact'
import QA from '../components/QA'
import Sticky from '../components/Sticky'
import ScrollVideo from '../components/ScrollVideo'
import Qrjun from '../products/Qrjun'




const Home = () => {



  return (
    <>

      {/* <span className="fixed blur-[200px] w-[600px] h-[600px] rounded-full top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 bg-white/20 dark:bg-white/40 "></span> */}
      <Navbar />
      <ScrollVideo/>
      <QA />
      <Qrjun />
      <Slider />

      <Sticky />
      <Contact />
      <Footer />
    </>
  )
}

export default Home